import React, { Component } from 'react';

import flaskFull from "../../img/flaskFull.svg";
import flaskEmpty from "../../img/flaskEmpty.svg";

const images = {
  "flask": flaskFull,
  "flaskEmpty": flaskEmpty
}

export class Graphics extends Component {

  getImg = () => {
    var reference = "flask"
    if(this.props.volume === 0){
      reference += "Empty"
    }
    return images[reference]
  }

  componentWillMount() {
    for(var image in images){
      if(!image.replace(this.props.type, '').includes(0)){
        const img = new Image();
        img.src = images[image];
      }
    }
  }

  render() {
    return (
      <div className="graphics">
        <img
        aria-label={"Flask"}
          className={(this.props.pour? 'pour': null)}
          style={{ pointerEvents: "none" }}
          src={this.getImg()}
          alt={this.props.type+" flask"}
          width= '80'
          aria-hidden={this.props.context==="Materials"?"true":"false"} />
      </div>
    )
  }
}